import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false, // 是否展示loading动画
    goodsInfo: { // 商品详情
    },
    userInfo: { // 用户信息
      userName: '',
      userMobile: '',
      token: ''
    },
    contentList: [], // 内容列表
    bannerList: [], // 轮播图
    searchGoodsList: [], // 搜索列表
    goodsList: [], // 商品列表
    classifyList: [], // 筛选分类
    currentClassifyId: '', // 当前分类ID 包括 列表页&详情页 == 面包屑使用
    homeList: [], // 首页推荐列表
  },
  getters,
  actions,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/index.js